import React from 'react';
import { useTree } from '../contexts/TreeContext';

export default function InviteNotification() {
  const { inviteNotifications, acceptIncomingInvite, dismissIncomingInvite, switchTree } = useTree();

  if (inviteNotifications.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 400,
      display: 'flex', flexDirection: 'column', gap: 10,
      maxWidth: 360, fontFamily: "'DM Sans', sans-serif",
    }}>
      {inviteNotifications.map(({ treeId, treeName, role }) => (
        <div key={treeId} style={{
          background: '#2C2418', color: '#F5EDE3',
          borderRadius: 12, padding: '14px 16px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
          border: '1px solid rgba(196,151,90,0.35)',
          display: 'flex', flexDirection: 'column', gap: 10,
        }}>
          {/* Icon + message */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <div style={{
              width: 36, height: 36, borderRadius: 8, flexShrink: 0,
              background: 'rgba(196,151,90,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <img src="/kt_logo.png" alt="" style={{ width: 22, height: 22, objectFit: 'contain' }} />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: '0 0 2px', fontSize: 13, fontWeight: 700, color: '#F5EDE3' }}>
                New tree shared with you
              </p>
              <p style={{ margin: 0, fontSize: 12, color: '#A0937F', lineHeight: 1.45 }}>
                <strong style={{ color: '#C4975A' }}>{treeName}</strong> has been shared with you as a{' '}
                <span style={{ textTransform: 'capitalize' }}>{role}</span>.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={async () => {
                const accepted = await acceptIncomingInvite(treeId, treeName);
                if (accepted) switchTree(treeId);
              }}
              style={{
                flex: 1, padding: '8px 0', borderRadius: 8, border: 'none',
                background: 'linear-gradient(135deg, #C4975A 0%, #A07840 100%)',
                color: '#2C2418', fontSize: 12, fontWeight: 700, cursor: 'pointer',
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Accept &amp; View
            </button>
            <button
              onClick={() => dismissIncomingInvite(treeId)}
              style={{
                flex: 1, padding: '8px 0', borderRadius: 8,
                border: '1px solid rgba(196,151,90,0.3)',
                background: 'transparent', color: '#A0937F', fontSize: 12, fontWeight: 600,
                cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
              }}
            >
              Later
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
